export default "__VITE_ASSET__e2c56d85__"